<template>
    <div class="layout-container">
        <div class="nav-container" v-if="showNavbar">
            <van-nav-bar
                v-if="isHomePage"
				title=""
				:border="false">
                <template #left>
					<img class="logo" :src="logo">
<!--                    <span style="color: #fff;padding-left: 0.3rem;">{{title}}</span>-->
				</template>
                <template v-if="showLogout" #right>
                    <span class="logout" style="padding-right:20px"  @click="listAccount" v-if="isWeChatBrowser">账户</span>
					<span class="logout" @click="logout">登出</span>
				</template>
			</van-nav-bar>
           <van-nav-bar
                v-else-if="noBack"
				:title="title"
				left-text="返回"
				left-arrow
				:border="false"
				@click-left="goBack">
				<template #right>
					<van-icon name="wap-home-o" @click="goHome"/>
				</template>
			</van-nav-bar>
            <van-nav-bar
                v-else
				:title="title"
				:border="false">
                <template #left>
					<img :src="logo">
				</template>
				<template #right>
					<van-icon name="wap-home-o" @click="goHome"/>
				</template>
			</van-nav-bar>
        </div>
        <div :class="layoutClass">
            <keep-alive :exclude="exclude">
                <router-view :key="pathKey"></router-view>
            </keep-alive>
        </div>
    </div>
</template>

<script>
	import log from 'utils/log'
    import utils from '@/utils/util'
    import logo from './../assets/logo2.png'
    import store from '@/store'
    import { removeToken, removeOpenId, loadOpenId} from '@/utils/cache'
    import apiUserPage from "api/user-page";
    export default {
        name: "Layout",
        data() {
            return {
                exclude:['Login','register','qrcode-pay','qrcode-pay-2','to-pay-2','pay_suc','pay_suc_qrcode','pay_suc_qrcode_2'],
            }
        },
        computed: {
            logo() {
                return logo
            },
            pathKey() {
                return this.$route.fullPath
			},

            showNavbar() {
                let r = false
                return false
			},

            layoutClass() {
                if (this.showNavbar) {
                    return 'route-container'
                } else {
                    return 'route-container-wx'
                }
			},

            title() {
                // log('router is', this.$route, this.$router)
                let key = this.$route.name
                let r = this.$i18n.t(`${key}.title`)
                return r
			},
			noBack() {
                let backList = []
                let p = this.$route.path
                return !backList.includes(p)
            },
            isHomePage() {
                let backList = ['/home','/redirect','/login','/register','/404','/result/pay_suc','/result/pay_suc_qrcode','/result/pay_suc_qrcode_2','/qrcode-pay','/qrcode-pay-2','/to-pay-2']
                let p = this.$route.path
                return backList.includes(p)
            },
            showLogout() {
                let backList = ['/home']
                let p = this.$route.path
                return backList.includes(p)
            },
            isWeChatBrowser() {
                return utils.isWeChatBrowser()
            }
        },
        methods: {
            listAccount(){
                 this.$router.push({ name: 'list-account' })
            },
            goBack() {
                console.log("goBack...")
                let p = this.$route.path
                if(p=='/anonymous-pay-detail'){
                    this.$router.push({
                        name: 'anonymous-pay'
                    })
                    return
                }
                 if(p=='/add-account'){
                    this.$router.push({
                        name: 'list-account'
                    })
                    return
                }
                let backList = ['/pay-confirm', '/choose-fee-detail']
                if (backList.includes(p)) {
                    this.$router.back()
                } else {
                    this.$router.push({
                        name: 'home'
                    })
                }
			},
            logout() {
                console.log("logout")
                this.$dialog.confirm({
                    title: '提示',
                    message: '是否退出登录？',
                })
                .then(() => {
                    console.log("logout go")
                    console.log(utils.isWeChatBrowser())
                    if(utils.isWeChatBrowser()) {
                        console.log("cancelUserBind: " + loadOpenId())
                        apiUserPage.cancelUserBind({ openId: loadOpenId() }).then( res => {
                            console.log(res)
                            removeToken()
                            removeOpenId()
                            this.$store.dispatch('mars/user/setLoginStatus', 0).then(() => {
                                this.$router.push({ path:'/login' })
                            })
                        }).catch((res)=>{
                            console.log("err")
                            console.log(res)
                            removeToken()
                            removeOpenId()
                            this.$store.dispatch('mars/user/setLoginStatus', 0).then(() => {
                                this.$router.push({ path:'/login' })
                            })
                        })
                    }
                    else{
                        console.log("logout go 2")
                        removeToken()
                        this.$router.replace({
                            name: 'login'
                        })
                    }
                })
                .catch(() => {
                    // on cancel
                     console.log("logout cancel")
                });

            },
            goHome() {
                console.log("goHome...")
                let p = this.$route.path
                if(p=='/anonymous-pay' || p=='/anonymous-pay-detail'){
                    this.$router.push({
                        name: 'login'
                    })
                    return
                }
                this.$router.push({path: '/home'})
            }

        },
    }
</script>

<style lang="scss" scoped>
    .logo {
        max-height: 70%;
    }
    .logo-title {
        color: #fff;
        padding-left: 0.3rem;
    }
    .logout{
        color: #fff;
    }
</style>
